import API from './API';
import { DictionaryNumber } from './types/generalTypes';
import { NetworkResponse, NetworkUser, NetworkVersion } from './types/networkTypes';
import { NetworkCreateSunkhronosCompany, NetworkSunkhronosCompany, NetworkSunkhronosCompanyCreate, NetworkSunkhronosCompanyUsage } from './types/applications/sunkhronosTypes';
import { NetworkClient, NetworkClientDetails } from './types/clientTypes';
import { NetworkInvoice } from './types/applications/invoiceTypes';
import { AxiosResponse } from 'axios';

/**
 * Static class with Network API call methods
 */
export default class Network {
    static getAppVersion = (): Promise<NetworkResponse<NetworkVersion>> => API.get(`utils/app/version?app_name=${import.meta.env.VITE_APP_NAME}`);

    static login = (username: string, password: string) => API.login(username, password);
    static logout = () => API.logout();
    static verifyAuth = (access: string) => API.post('auth/verify', { access });

    static fetchUser = (): Promise<NetworkResponse<NetworkUser>> => API.get('user/current');

    static fetchSunkhronosCompanies = (date: string): Promise<NetworkResponse<NetworkSunkhronosCompany[]>> => API.get(`integrations/internal/sunkhronos/companies?date=${date}`);
    static fetchSunkhronosCompanyDetails = (id: number): Promise<NetworkResponse<NetworkSunkhronosCompany>> => API.get(`integrations/internal/sunkhronos/companies/${id}/details`);
    static fetchSunkhronosCompanyUsage = (id: number, startDate: string, endDate: string): Promise<NetworkResponse<DictionaryNumber<NetworkSunkhronosCompanyUsage>>> => API.get(`integrations/internal/sunkhronos/companies/${id}/usage?startDate=${startDate}&endDate=${endDate}`);

    static fetchClients = (): Promise<NetworkResponse<NetworkClient[]>> => API.get(`client/all`);
    static fetchClientDetails = (id: number): Promise<NetworkResponse<NetworkClientDetails>> => API.get(`client/details?id=${id}`);

    static fetchInvoices = (id: number): Promise<NetworkResponse<NetworkInvoice[]>> => API.get(`invoice/company?id=${id}`);

    static updateSunkhronosCompany = (id: number, formData: FormData, date: string): Promise<NetworkResponse<NetworkSunkhronosCompany>> => API.post(`integrations/internal/sunkhronos/companies/${id}?date=${date}`, formData);
    static fetchContract = (id: number): Promise<AxiosResponse<Blob>> => API.getFullResponse(`integrations/internal/sunkhronos/companies/${id}/contract`, { responseType: 'blob', });
    static fetchOffer = (id: number): Promise<AxiosResponse<Blob>> => API.getFullResponse(`integrations/internal/sunkhronos/companies/${id}/offer`, { responseType: 'blob', });

    static renewSunkhronosLicence = (id: number): Promise<NetworkResponse<NetworkSunkhronosCompany>> => API.post(`integrations/internal/sunkhronos/companies/${id}/licence/renew`);

    static createNewCompany = (company: NetworkSunkhronosCompanyCreate): Promise<NetworkResponse<NetworkCreateSunkhronosCompany>> => API.post(`integrations/internal/sunkhronos/companies`, company);
}
